import axios from "axios";

// Empty BACKEND_URL means same-origin: the panel calls /api on its own domain and a
// Cloudflare Pages worker proxies it to the backend. This removes any dependency on a
// separate api subdomain resolving on the visitor's network.
export const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL as string) || "";
export const API = `${BACKEND_URL}/api`;
export const WS_URL = BACKEND_URL
  ? `${BACKEND_URL.replace(/^http/, "ws")}/api/ws/live`
  : `${window.location.origin.replace(/^http/, "ws")}/api/ws/live`;

export const api = axios.create({ baseURL: API, withCredentials: true });

/** Super admins can work inside any tenant. The backend honours X-Tenant-Id only for users
 *  holding the "*" permission, so a normal user setting this header changes nothing. */
export const TENANT_KEY = "tg_tenant";
export const getActiveTenant = () => localStorage.getItem(TENANT_KEY) || "";
export function setActiveTenant(id: string | null) {
  if (id) localStorage.setItem(TENANT_KEY, id);
  else localStorage.removeItem(TENANT_KEY);
}

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("tg_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  const tenant = getActiveTenant();
  if (tenant) cfg.headers["X-Tenant-Id"] = tenant;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      localStorage.removeItem("tg_token");
      localStorage.removeItem(TENANT_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(err);
  },
);

export function errorMessage(e: any): string {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || String(d);
}

export async function download(path: string, filename: string) {
  const res = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
